// src/components/Footer.js
import React from "react";
import "../styles/footer.css";
import { FaInstagram, FaFacebookF } from "react-icons/fa";

const Footer = ({ onPrivacyClick }) => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-inner">
        {/* LEFT SIDE */}
        <div className="footer-left">
          <p className="footer-brand">KBIA poklon kutije</p>
          <p className="footer-copy">
            &copy; {year} KBIA, obrt za izradu poklona. Sva prava pridržana.
          </p>
          <p className="footer-author">
            Izrada:&nbsp;
            <a href="https://s3le.com.hr" target="_blank" rel="noreferrer">
              S3LE Web Design
            </a>
          </p>
          <button 
            className="footer-privacy-link"
            onClick={onPrivacyClick}
          >
            Politika privatnosti
          </button>
        </div>

        {/* RIGHT SIDE */}
        <div className="footer-right">
          {/* FACEBOOK */}
          <a
            className="social fb"
            href="https://www.facebook.com/poklonkutijeKBIA"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>

          {/* INSTAGRAM */}
          <a
            className="social insta"
            href="https://www.instagram.com/poklonkutijedesignbykbia"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>

          {/* SCROLL TO TOP */}
          <button
            className="footer-top"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Na vrh ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
